import React from "react";
import { Page } from "react-pdf";

import { Placeholder } from "../placeholder/placeholder";

export type PdfPageProps = {
  onRenderSuccess: () => void;
  pageNumber: number;
  visible: boolean;
  scale: number;
};

export const PdfPage: React.FC<PdfPageProps> = ({
  onRenderSuccess,
  pageNumber,
  visible,
  scale,
}) => {
  return (
    <div
      data-pdf-page-number={pageNumber}
      data-testid={`page_${pageNumber}`}
      className="page"
      key={`pdf_page_${pageNumber}`}
    >
      <Page
        key={`page_${pageNumber}`}
        scale={scale}
        pageNumber={pageNumber}
        renderMode={visible ? "canvas" : "custom"}
        customRenderer={Placeholder}
        renderTextLayer={visible}
        renderAnnotationLayer={visible}
        renderForms={undefined}
        onRenderSuccess={() => onRenderSuccess()}
      ></Page>
    </div>
  );
};
